<template>
  <div class="plan-type">
    <van-popup v-model="planTypePopup" :round="true" :style="{ 'width': '90%' }" get-container="#app">
      <div class="plan-type-content">
        <div class="popup-title">{{ currentPlanInfo.targetId ? $t('shared.addToVisitPlan') : $t('shared.selectType') }}</div>
        <div class="plan-section">
          <div class="section-item" @click="toPage('oper1', `/shared/selectVisitPlan?pageType=store&planId=${currentPlanInfo.id}`)">
            <div class="item-icon">
              <van-icon v-if="currentPlanInfo.targetId" name="add-o" color="#fff" size="18" />
              <van-icon v-else name="shop-o" color="#fff" size="18" />
            </div>
            <div class="item-info">
              <div class="desc-txt">{{ currentPlanInfo.targetId ? $t('shared.createNewVisitPlan') : $t('shared.store') }}</div>
              <div class="desc-tip">{{ currentPlanInfo.targetId ? $t('shared.automaticallyAddCurrentItemAfterCreation') : $t('shared.addRetailStoresToThePlan') }}</div>
            </div>
          </div>
          <div class="section-item" @click="toPage('oper2', `/shared/selectVisitPlan?pageType=distributor&planId=${currentPlanInfo.id}`)">
            <div class="item-icon" style="background-color: #3da50f;">
              <van-icon v-if="currentPlanInfo.targetId" name="orders-o" color="#fff" size="18" />
              <van-icon v-else name="location-o" color="#fff" size="18" />
            </div>
            <div class="item-info">
              <div class="desc-txt">{{ currentPlanInfo.targetId ? $t('shared.addToExistingPlan') : $t('shared.distributor') }}</div>
              <div class="desc-tip">{{ currentPlanInfo.targetId ? $t('shared.selectFromExistingPlan') : $t('shared.addDistributorsToThePlan') }}</div>
            </div>
          </div>
        </div>
        <div class="operate-btn">
          <van-button type="primary" @click="planTypePopup = false">{{ $t('button.cancel') }}</van-button>
        </div>
      </div>
    </van-popup>
    <XuPlanSelect v-model="showPlanPicker" :currentPlanInfo="currentPlanInfo" @confirm="onConfirmStore" />
  </div>
</template>

<script>
import { visitPlanAddApi } from '@/api/visitPlan'
import { Toast } from 'vant'
export default {
  components: {
    XuPlanSelect: () => import('@/components/XuPlanSelect')
  },
  props: {
    currentPlanInfo: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      planTypePopup: false,
      showPlanPicker: false
    }
  },
  methods: {
    toPage (type, url) {
      if (this.currentPlanInfo.targetId) {
        if (type === 'oper1') {
          this.$emit('handlePlan', 'add')
        } else {
          this.showPlanPicker = true
        }
        this.planTypePopup = false
      } else {
        this.$router.push(url)
        this.planTypePopup = false
      }
    },
    onConfirmStore (item) {
      const data = {
        id: item.id,
        planName: item.planName,
        planTime: item.planTime,
        isAddSchedule: item.isAddSchedule,
        targetId: this.currentPlanInfo.targetId || '',
        targetType: this.currentPlanInfo.targetType || ''
      }
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      visitPlanAddApi(data).then(res => {
        Toast.clear()
        this.$router.push(`/visitPlan/detail?planId=${item.id}`)
      })
      this.showPlanPicker = false
    }
  }
}
</script>

<style lang="less" scoped>
.plan-type {
}
.plan-type-content {
  padding: 10px 18px 20px 18px;
  .popup-title {
    font-weight: bold;
    font-size: 16px;
    text-align: center;
    margin-bottom: 10px;
  }
  .plan-section {
    .section-item {
      display: flex;
      align-items: center;
      padding: 16px 10px;
      background-color: #f8f9fa;
      margin-bottom: 10px;
      border-radius: 10px;
      .item-icon {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 33px;
        height: 33px;
        margin-right: 10px;
        border-radius: 8px;
        background-color: #2764e1;
      }
      .desc-txt {
        font-weight: bold;
      }
      .desc-tip {
        font-size: 11px;
        color: #7f7f7f;
      }
    }
  }
  .operate-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 20px;
    justify-content: space-between;
    /deep/.van-button {
      width: 100%;
      height: 40px;
      background-color: #f5f5f5;
      border: 1px solid #f5f5f5;
      border-radius: 8px;
      color: #000;
    }
  }
}
</style>
